const WIDTH = 'width';
const HEIGHT = 'height';
const X = 'x';
const Y = 'y';
const FULL_CIRCLE_ANGLE = 360;
const TRANSPARENT = 'transparent';
const START = 'start';
const END = 'end';
const Markers = {
    none: 'none',
    arrowStart: 'ArrowStart',
    filledCircle: 'FilledCircle',
    arrowEnd: 'ArrowEnd'
};
const DEG_TO_RAD = Math.PI / 180;
const EPSILON = 1e-06;
const CHANGE = 'change';
const Cursors = {
    arrow: 'default',
    grip: 'pointer',
    cross: 'pointer',
    add: 'pointer',
    move: 'move',
    select: 'pointer',
    south: 's-resize',
    east: 'e-resize',
    west: 'w-resize',
    north: 'n-resize',
    rowresize: 'row-resize',
    colresize: 'col-resize'
};
const HIT_TEST_DISTANCE = 10, AUTO = 'Auto', TOP = 'Top', RIGHT = 'Right', LEFT = 'Left', BOTTOM = 'Bottom', DEFAULT_SNAP_SIZE = 10, DEFAULT_SNAP_ANGLE = 10, DRAG_START = 'dragStart', DRAG = 'drag', DRAG_END = 'dragEnd', ITEMROTATE = 'itemRotate', ITEMBOUNDSCHANGE = 'itemBoundsChange', MIN_SNAP_SIZE = 5, MIN_SNAP_ANGLE = 5, MOUSE_ENTER = 'mouseEnter', MOUSE_LEAVE = 'mouseLeave', ZOOM_START = 'zoomStart', ZOOM_END = 'zoomEnd', SCROLL_MIN = -2e4, SCROLL_MAX = 20000, FRICTION = 0.90, FRICTION_MOBILE = 0.93, VELOCITY_MULTIPLIER = 5, PAN = 'pan', ROTATED = 'rotated', SOURCE = 'source', TARGET = 'target', HANDLE_NAMES = {
    '-1': SOURCE,
    '1': TARGET
};
const ConnectionEditing = 'Connection Editing';
const NS = '.kendoDiagram', CASCADING = 'cascading', CLICK = 'click', ERROR = 'error', MAXINT = 9007199254740992, SELECT = 'select', NONE = 'none', DEFAULT_CANVAS_WIDTH = 600, DEFAULT_CANVAS_HEIGHT = 600, DEFAULT_SHAPE_TYPE = 'rectangle', DEFAULT_SHAPE_WIDTH = 100, DEFAULT_SHAPE_HEIGHT = 100, DEFAULT_SHAPE_MINWIDTH = 20, DEFAULT_SHAPE_MINHEIGHT = 20, DEFAULT_SHAPE_POSITION = 0, DEFAULT_CONNECTION_BACKGROUND = 'Yellow', MAX_VALUE = Number.MAX_VALUE, MIN_VALUE = -Number.MAX_VALUE, ABSOLUTE = 'absolute', TRANSFORMED = 'transformed', MOUSEWHEEL_NS = 'DOMMouseScroll' + NS + ' mousewheel' + NS, MOBILE_ZOOM_RATE = 0.05, MOBILE_PAN_DISTANCE = 5, CONNECTION_CONTENT_OFFSET = 5;

export { ABSOLUTE, AUTO, BOTTOM, CASCADING, CHANGE, CLICK, CONNECTION_CONTENT_OFFSET, ConnectionEditing, Cursors, DEFAULT_CANVAS_HEIGHT, DEFAULT_CANVAS_WIDTH, DEFAULT_CONNECTION_BACKGROUND, DEFAULT_SHAPE_HEIGHT, DEFAULT_SHAPE_MINHEIGHT, DEFAULT_SHAPE_MINWIDTH, DEFAULT_SHAPE_POSITION, DEFAULT_SHAPE_TYPE, DEFAULT_SHAPE_WIDTH, DEFAULT_SNAP_ANGLE, DEFAULT_SNAP_SIZE, DEG_TO_RAD, DRAG, DRAG_END, DRAG_START, END, EPSILON, ERROR, FRICTION, FRICTION_MOBILE, FULL_CIRCLE_ANGLE, HANDLE_NAMES, HEIGHT, HIT_TEST_DISTANCE, ITEMBOUNDSCHANGE, ITEMROTATE, LEFT, MAXINT, MAX_VALUE, MIN_SNAP_ANGLE, MIN_SNAP_SIZE, MIN_VALUE, MOBILE_PAN_DISTANCE, MOBILE_ZOOM_RATE, MOUSEWHEEL_NS, MOUSE_ENTER, MOUSE_LEAVE, Markers, NONE, NS, PAN, RIGHT, ROTATED, SCROLL_MAX, SCROLL_MIN, SELECT, SOURCE, START, TARGET, TOP, TRANSFORMED, TRANSPARENT, VELOCITY_MULTIPLIER, WIDTH, X, Y, ZOOM_END, ZOOM_START };
